export default "__VITE_ASSET__C4Vra2tU__"